import React from 'react';
import styled, { css } from 'styled-components';
import { DEVICE_SIZE, mq } from '../../utils/mq';
import { useImageComponent } from '../../utils/component';
import { DateDisplay } from '../../atoms/date/utils';
import type { ImageProps } from '../../atoms/types';

const Embed = styled.div`
  border-radius: 10px;
  background: var(--color-alt-4);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  margin: var(--spacer-s) 0;
  position: relative;
  top: 0;
  transition: top 0.3s;

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      flex-direction: column;
    `,
  )}
`;

const Description = styled.div`
  padding: 30px;
  transition: color 0.3s;
  width: auto;
`;

const Title = styled.a`
  font-family: var(--theme-typography-primary-font);
  text-decoration: none;
  font-size: 19px;
  font-weight: 600;
  line-height: 19px;
  margin: 0 0 15px;
`;

const ImgEmbed = styled.div`
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
  height: auto;
  min-height: 214px;
  width: 180px;

  ${mq.lte(
    DEVICE_SIZE.LARGE,
    css`
      width: 100%;

      picture {
        width: 100%;
      }

      img {
        object-fit: cover;
      }
    `,
  )}
`;

const Desc = styled.div`
  padding-top: 10px;
  font-size: 18px;
`;

const Text = styled.div`
  color: var(--text-color);
`;

const Label = styled.div`
  color: #99a4ba;
  font-size: 13px;
  font-weight: 600;
  line-height: 19px;
  margin: 0 0 15px;
  text-transform: uppercase;
`;

const DateContainer = styled.div`
  color: black;
  font-size: 13px;
  display: flex;
  gap: 20px;
  line-height: 19px;
  padding-top: 10px;
`;

interface ClubicContainerProps {
  embedTitle: string;
  embedDescription: string;
  embedImageUrl?: string;
  embedImageId?: string;
  embedLabel?: string;
  embedType?: string;
  embedItemType?: string;
  embedSponso?: boolean;
  embedDate?: string;
  embedExtensionImg?: string;
  embedDisplayedDate?: boolean;
  embedTitleImg?: string;
  url: string;
}

export function WebContainer({
  embedTitle,
  embedDescription,
  embedImageUrl,
  url,
  embedImageId,
  embedLabel,
  embedItemType,
  embedSponso,
  embedDate,
  embedExtensionImg,
  embedTitleImg,
  embedDisplayedDate,
}: ClubicContainerProps) {
  const ImageComponent = useImageComponent();

  let imageId: string = null;
  if (embedImageUrl?.includes('pic.clubic.com')) {
    const match = embedImageUrl.match(/\/images\/(\d+)\/raw/);
    imageId = match[1];
  }
  if (embedImageId) {
    imageId = embedImageId;
  }

  const imageProps: ImageProps = {
    imageId,
    alt: embedTitle,
    mobileWidth: 294,
    mobileHeight: 214,
    desktopWidth: 180,
    desktopHeight: 214,
    extension: embedExtensionImg,
    title: embedTitleImg,
  };

  let date = null;
  if (embedDate && embedDisplayedDate) {
    date = DateDisplay({ dateTime: embedDate });
  }

  return (
    <Embed>
      {imageId && (
        <ImgEmbed>
          <ImageComponent {...imageProps} />
        </ImgEmbed>
      )}
      <Description>
        {embedLabel && <Label>{embedLabel}</Label>}
        <Title href={url}>{embedTitle}</Title>
        {embedDescription && <Desc>{embedDescription}</Desc>}
        {date && (
          <DateContainer>
            {date && <Text>{date}</Text>}
            {embedSponso && <Text>Contenu Sponsorisé</Text>}
            {embedItemType && <Text>{embedItemType}</Text>}
          </DateContainer>
        )}
      </Description>
    </Embed>
  );
}

export default WebContainer;
